var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"found-card",attrs:{"src":_vm.quiz.get('card').get('filePath')}})}
var staticRenderFns = []

export { render, staticRenderFns }